<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgement">
<h1>Acknowledgement</h1>
<p>I would like to thank family, friends and work colleagues (you know who you are) for their positive feedback after taking the time to read this book. It was their positive feedback that encouraged me to pursue the possibility of getting it published. I would also like to thank, Austin Macauley Publishers, for all their hard work and making it possible.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch003.vue?bd99578e